import { render } from "./ObjManageAdd.vue?vue&type=template&id=2d34736b&scoped=true"
import script from "./ObjManageAdd.vue?vue&type=script&lang=js"
export * from "./ObjManageAdd.vue?vue&type=script&lang=js"

import "./ObjManageAdd.vue?vue&type=style&index=0&id=2d34736b&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d34736b"]])

export default __exports__